<template>
    <div v-if="record" class="lane__closure__block__mobile d-flex" :class="blockSwipped ? 'swipped' : ''">
        <div :class="attentionBarClass(record)" class="block-wrapper" v-touch:swipe.left="swipeLeftHandler" @click="blockSwipped ? blockSwipped = false : ''" v-touch:swipe.right="swipeRightHandler">
            <div @click="showDetail(record.id)" class="content">
                <div class="head" v-if="hasProject">
                    <h2 v-html="displayProject"></h2>
                </div>
                <div class="body">
                    <div class="detail">
                        <h4 :class="hasProject ? 'hide-badge' : ''" v-html="record.affectedStreetFull.replace('<br/>', ', ')"></h4>
                    </div>
                    <div class="info">
                        <div class="status clearfix">
							<span class="sts">
								<strong>Status</strong>: {{ record.status }}
							</span>
							<span v-if="record.trafficManagementRef" class="laneids">
								<strong>TM</strong> {{ record.trafficManagementRef }}
							</span>
							<span v-else class="laneids">
								<strong>LCR</strong> {{ record.id }}
							</span>

                        </div>
						<span class="dates" v-html="record.date"></span>
                    </div>
                    <div v-if="displayAttentionBar(record)" class="notification">
                    	<span v-show="!isNewViolationNotificationText(record) && displayAttentionBarContravention(record.notificationEntries)"
                    	    :class="displayAttentionBarEmergency(record) || displayAttentionBarUpdated(record.notificationEntries) ||
                    	        displayAttentionBarMessage(record.notificationEntries) || displayAttentionBarCallToAction(record.notification) ? ['attention__violation'] : ['attention__violation']"
                    	    >New Violation</span>

                        <span  v-show="isNewViolationNotificationText(record) &&  displayAttentionBarContravention(record.notificationEntries)"
                            :class="displayAttentionBarEmergency(record) || displayAttentionBarUpdated(record.notificationEntries) ||
                                displayAttentionBarMessage(record.notificationEntries) || displayAttentionBarCallToAction(record.notification) ? ['attention__violation'] : ['attention__violation']"
                            >New Violation</span>


                        <!-- <span v-show="displayAttentionBarMessage(record.notificationEntries)"
                            :class="displayAttentionBarEmergency(record) || displayAttentionBarUpdated(record.notificationEntries) || displayAttentionBarCallToAction(record.notification) ? ['attention__message', 'border-right'] : ['attention__message']"
                            ><img src="/img/nav/icon-messages-list.svg" alt="Messages" /> New Message</span> -->

                        <!-- <span v-show="displayAttentionBarEmergency(record) || displayAttentionBarUpdated(record.notificationEntries)"
                            :class="displayAttentionBarCallToAction(record.notification) ? ['attention__emergency'] : ['attention__emergency']"
                            >
                            {{displayAttentionBarUpdated(record.notificationEntries) ? 'Updated ' : ''}}{{displayAttentionBarEmergency(record) ? 'Emergency ' : ''}}Request
                        </span> -->

                        <span v-show="displayAttentionBarUpdated(record.notificationEntries)"
                            :class="displayAttentionBarCallToAction(record.notification) ? ['attention__emergency'] : ['attention__emergency']"
                            >
                            {{displayAttentionBarUpdated(record.notificationEntries) ? 'Updated ' : ''}}{{displayAttentionBarEmergency(record) ? 'Emergency ' : ''}}Request
                        </span>

                        <span v-if="!isNewViolationNotificationText(record)" style="display: inline-block" v-show="displayAttentionBarCallToAction(record.notification)">
                            {{ record.notification.text }}
                        </span>
                        <span style="display: inline-block" v-show="displayAttentionBarLcAndR(record)">
                            {{ attentionBarLcAndR(record) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="mobile__controls">
                <div class="d-flex control-row">
                    <div @click="showMap(record.id)" class="control">
                        <div>
                            <img src="@/assets/lc-map.svg"/>
                            Map
                        </div>
                    </div>
                    <div v-show="canReportClosure()" @click="onReportLaneClosure" class="control">
                        <div>
                            <img src="/img/newicon.e44be4ca.svg"/>
                            Closure
                        </div>
                    </div>
                    <div v-show="canReportRestriction()" @click="onReportRestriction" class="control">
                        <div>
                            <img src="/img/reportclosure.cc9a7e91.svg"/>
                            Restriction
                        </div>
                    </div>
                    <!-- <div class="control">
                        <div>
                            <img src="@/assets/lc-message.svg"/>
                            Messages
                        </div>
                    </div>
                    <div @click="showEdit(record.id)" class="control">
                        <div>
                            <img src="@/assets/lc-header-updates-white.svg"/>
                            Updates
                        </div>
                    </div> -->
                    <div @click="showEdit(record.id)" class="control">
                        <div>
                            <img src="@/assets/lc-edit.svg"/>
                            Edit
                        </div>
                    </div>
                    <!-- <div class="control" @click="showDetail(record.id)">
                        <div>
                            <img src="@/assets/lc-detail.svg"/>
                            Details
                        </div>
                    </div>
                    <div class="control" @click="showAttachment(record.id)">
                        <div>
                            <img src="@/assets/lc-attachments.svg"/>
                            Attachments
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Format from './../utility/Format';
import LaneClosureRequest from '../models/LaneClosureRequest';
export default {
    props: ['record'],
    data() {
        return {
            blockSwipped: false
        }
    },
    computed: {


        laneClosureRequest: function() {
            return new LaneClosureRequest(this.record);
        },
        hasProject: function() {
        	let currentUser = this.$store.getters.userInfo();
        	if (this.record.ownerId && ( this.record.ownerProjectName != null && this.record.ownerProjectName != "") && currentUser.allUserOrganizations.includes(this.record.owner.organizationId)) {
        	    return true;
        	} else {
        	    if (this.record.requesterProjectName != null && this.record.requesterProjectName != "") {
        	    	return true;
        	    }
        	}
        	return false;
        },
        displayProject: function() {
			let location = '';
			if (this.record.conflicts && this.record.conflicts.length > 0) {
				if (this.record.lcrChangeRequestId) {
					location += "<span class='badge bg-changes'>CHANGES</span> ";
				}
				if (this.record.isEmergency == 1) {
					location += "<span class='badge bg-emergency'>EMERGENCY</span> ";
				}
				location += `<span class="badge bg-danger bg-conflict">${this.record.conflicts.length} Conflict${this.record.conflicts.length > 1 ? 's' : ''}</span> `;
				if (this.record.isUnderTwoHours == 1) {
					location += "<span class='badge bg-two-hours'>2 hours</span>";
				}
				if(location != '')
					location += "<br />";
			} else {
				if (this.record.lcrChangeRequestId) {
					location += "<span class='badge bg-changes'>CHANGES</span> ";
				}
				if (this.record.isEmergency == 1) {
					location += "<span class='badge bg-emergency'>EMERGENCY</span> ";
				}
				if (this.record.isUnderTwoHours == 1) {
					location += "<span class='badge bg-two-hours'>2 hours</span> ";
				}
				if(location != '')
					location += "<br />";
			}


            let currentUser = this.$store.getters.userInfo();
            if (this.record.ownerId && this.record.ownerProjectName && currentUser.allUserOrganizations.includes(this.record.owner.organizationId)) {
                return location + this.record.ownerProjectName;
            } else {
                return location + this.record.requesterProjectName;
            }
        }
    },
    methods: {
    	isNewViolationNotificationText(data) {
    		if (data) {
    			if (data.notification) {
    				if (data.notification.text == "New Violation") {
    					return true;
    				}
    			}
    		}
    		return false;
    	},
    	getOrganizationIdTreeList(user) {
    		if (this.user) {
	    		if (user.organizationIdTree) {
	    			let treeString = user.organizationIdTree;
	    			let treeList = treeString.split("|");
	    			treeList.pop();
	    			treeList.shift();
	    			treeList.reverse();
	    			return treeList;
	    		} else {
	    			return new Array(user.organizationId);
	    		}
	    	}
	    	return new Array();
    	},
		displayAttentionBarMessage(notification) {
			if (notification) {
				let messageNotifications = notification.filter(x => ['lcr-new-message','new-message','contravention-new-message'].includes(x.notificationTypeId));
				return messageNotifications.length > 0;
			}

			return false;
		},
        displayAttentionBarContravention(notification) {
			if (notification) {
				let contraventionNotifications = notification.filter(x => x.notificationTypeId == 'new-contravention');
				return contraventionNotifications.length > 0;
			}

			return false;
		},
		attentionBarLcAndR(row) {
			if (row) {
				if (row.notification && row.notification.typeId == "lc-not-opened") {
					return Format.searchByKeyInArray('r-not-removed', 'id', LaneClosureRequest.getNotificationTypeIdOptions);
				} else if (row.notification && row.notification.typeId == "r-not-removed") {
					return Format.searchByKeyInArray('lc-not-opened', 'id', LaneClosureRequest.getNotificationTypeIdOptions);
				}
			}
		},
        displayAttentionBarLcAndR(row) {
			if (row) {
				if (typeof row.notificationEntries != 'undefined' && row.notification && (row.notification.typeId == "lc-not-opened" || row.notification.typeId == "r-not-removed")) {
					let notOpenedNotifications = row.notificationEntries.filter(x => x.notificationTypeId == "lc-not-opened");
					let notRemovedNotifications = row.notificationEntries.filter(x => x.notificationTypeId == "r-not-removed");

					return notOpenedNotifications.length > 0 && notRemovedNotifications > 0;
				}
			}

			return false;
		},
        attentionBarClass(record) {
			if (record) {
				if (record.notification && record.notification.typeId && record.notification.color) {
                    return "attention__type-" + record.notification.typeId +"-mobile " +  record.notification.color + "-border-mobile";
                } else if (record.isEmergency) {
                    return "attention__type-lc-not-opened-mobile red-border-mobile";
                } else {
                    return "border-mobile";
                }
			}
			return "";

		},
        displayAttentionBar(record) {
			if (record) {
				// if (record.isEmergency) {
    //                 return true;
    //             }
                if (record.unreadMessagesCount > 0) {
                    return true;
                }
                if (record.messageNotificationDate) {
                    return true;
                }
                if (record.modifiedNotificationDate) {
                    return true;
                }
                if (record.alertNotificationDate) {
                    return true;
                }
                if (record.contraventionNotificationDate) {
                    return true;
                }
                if (record.reminderNotificationDate) {
                    return true;
                }
                if (record.notification.text) {
                	if (record.notification.text == "New Message") {
                		return false;
                	}
                    return true;
                }
			}
			return false;
		},
		displayAttentionBarCallToAction(notification) {
			if (notification) {
				return notification.text && !(notification.typeId == "lcr-new-message") && !(notification.typeId == "lcr-updated");
			}
			return false;
		},
        displayAttentionBarEmergency(row) {
			if (row) {
				return row.isEmergency;
			}

			return false;
		},
		displayAttentionBarUpdated(notification) {
			if (notification) {
					let updatedNotifications = notification.filter(x => x.notificationTypeId == 'lcr-updated');
					return updatedNotifications.length > 0;
				}

				return false;
		},
        canReportClosure() {
        	if (this.laneClosureRequest && this.$store.getters.userInfo()) {

        		if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
        			let canReport = false;
        			let thisUserId = this.$store.getters.userId();
        			let thisOrgId = this.$store.getters.userInfo().organizationId;
        			let canOrg = this.$store.getters.userHasPermission('rlc_org');
        			let canMine = this.$store.getters.userHasPermission('rlc_mine');
        			let canAll = this.$store.getters.userHasPermission('rlc_all');

        			if (!canMine && !canAll && !canOrg) {
        				return false;
        			}

        			if (canAll) {
        				canReport = true;
        			}

        			if (!canReport) {
        				if (this.laneClosureRequest.closureReporterId == thisUserId && (canOrg || canMine)) {
        					canReport = true;
        				}
        				if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
        					canReport = true;
        				}
        			}

        			let x = 0;
        			let orgs = [];


        			if (!canReport) {
        				if (canOrg) {
        					orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
        					if (orgs.includes(""+thisOrgId)) {
        						canReport = true;
        					}
        				}
        			}
        			if (!canReport) {
        				if (this.laneClosureRequest.altRequester) {
        					for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
        						if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
        							canReport = true; // they can always report if they are an alternate requester...
        						}
        						if (canReport == false) {
        							if (canOrg) {
        								orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
        								if (orgs.includes(""+thisOrgId)) {
        									canReport = true;
        								}
        							}
        						}
        					}
        				}
        			}

        			if (!canReport) {
        				if (this.laneClosureRequest.altClosureReporter) {
        					for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
        						if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
        							canReport = true;
        						}
        						if (canReport == false) {
        							if (canOrg) {
        								orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
        								if (orgs.includes(""+thisOrgId)) {
        									canReport = true;
        								}
        							}
        						}
        					}

        				}
        			}

        			if (canReport) {
        				let x = 0;
        				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
        					if (this.laneClosureRequest.block[x].lane) {
        						if (this.laneClosureRequest.block[x].lane.length > 0) {
        							return true;
        						}
        					}
        					if (this.laneClosureRequest.block[x].bicycle) {
        						if (this.laneClosureRequest.block[x].bicycle.length > 0) {
        							return true;
        						}
        					}
        					if (this.laneClosureRequest.block[x].sidewalk) {
        						if (this.laneClosureRequest.block[x].sidewalk.length > 0) {
        							return true;
        						}
        					}
        				}
        			}
        		}
        	}
        	return false;
        },
        canReportRestriction() {

        	if (this.laneClosureRequest && this.$store.getters.userInfo()) {
        		if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
        			let canReport = false;
        			let thisUserId = this.$store.getters.userId();
        			let thisOrgId = this.$store.getters.userInfo().organizationId;
        			let canOrg = this.$store.getters.userHasPermission('rr_org');
        			let canMine = this.$store.getters.userHasPermission('rr_mine');
        			let canAll = this.$store.getters.userHasPermission('rr_all');

        			if (!canMine && !canAll && !canOrg) {
        				return false;
        			}

        			if (canAll) {
        				canReport = true;
        			}

        			if (!canReport) {
        				if (this.laneClosureRequest.restrictionReporterId == thisUserId && (canOrg || canMine)) {
        					canReport = true;
        				}
        				if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
        					canReport = true;
        				}
        			}

        			let x = 0;
        			let orgs = [];


        			if (!canReport) {
        				if (canOrg) {
        					orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
        					if (orgs.includes(""+thisOrgId)) {
        						canReport = true;
        					}
        				}
        			}
        			if (!canReport) {
        				if (this.laneClosureRequest.altRequester) {
        					for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
        						if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
        							canReport = true; // they can always report if they are an alternate requester...
        						}
        						if (canReport == false) {
        							if (canOrg) {
        								orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
        								if (orgs.includes(""+thisOrgId)) {
        									canReport = true;
        								}
        							}
        						}
        					}
        				}
        			}

        			if (!canReport) {
        				if (this.laneClosureRequest.altRestrictionReporter) {
        					for (x = 0; x < this.laneClosureRequest.altRestrictionReporter.length; x++) {
        						if (thisUserId + "" == this.laneClosureRequest.altRestrictionReporter[x].userId + "") {
        							canReport = true;
        						}
        						if (canReport == false) {
        							if (canOrg) {
        								orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRestrictionReporter[x]);
        								if (orgs.includes(""+thisOrgId)) {
        									canReport = true;
        								}
        							}
        						}
        					}

        				}
        			}

        			if (canReport) {
        				let x = 0;
        				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
        					if (this.laneClosureRequest.block[x].restriction.length > 0) {
        						return true;
        					}
        				}
        			}
        		}
        	}
        	return false;

        },
        onReportRestriction() {
			if (this.record.id) {
				this.$router.push({ name: "ReportRestriction", params: { id: this.record.id } });
			}
		},
		onReportLaneClosure() {
			if (this.record.id) {
				this.$router.push({ name: "ReportClosure", params: { id: this.record.id } });
			}
		},
        showDetail(id) {
            if(!this.blockSwipped) {
                let currentRouteName = this.$route.name;
                if(currentRouteName == 'ReportClosureSearch') {
                    // this.$router.push({name:"ReportClosure", params:{id: id}});
                    this.$router.push({name:"ViewLaneClosureRequest", params:{id: id}});
                } else if(currentRouteName == 'LaneClosureList') {
                    this.$router.push({name:"ViewLaneClosureRequest", params:{id: id}});
                } else if(currentRouteName == 'ReportContraventionSearch') {
                    this.$router.push({name:"LaneClosureRequestContraventions", params:{id: id}});
                } else if(currentRouteName == 'ContraventionList') {
                    this.$router.push({name:"LaneClosureRequestContraventions", params:{id: id}});
                } else {
                    this.$router.push({name:"ViewLaneClosureRequest", params:{id: id}});
                }
            }
        },
        showMap(id) {
            Vue.prototype.$bus.$emit("map:toggle", null, null);
            this.$nextTick(() => {
                this.zoomToLaneClosureRequest(id);
                this.record.mapShown = this.$mapShown;
            });
        },
        zoomToLaneClosureRequest(lcrId) {
			Vue.prototype.$bus.$emit('map:close-street-view');
			this.$store.dispatch("map/zoomToLaneClosureRequestId", lcrId);
		},
        showEdit(id) {
			this.$router.push({name:"EditLaneClosureRequest", params:{id: id}});
		},
        showAttachment(id) {
			this.$router.push({name:"LaneClosureRequestAttachments", params:{id: id}});
		},
        swipeLeftHandler() {
            this.blockSwipped = true;
        },
        swipeRightHandler() {
            this.blockSwipped = false;
        },
    }
}
</script>